export const PATH_LEAD_EDIT = ''


export const REDUCER_NAME = 'lead'




// WEBPACK FOOTER //
// ./src/modules/lead/state/const.js